import { Component, OnInit, Input, Output,EventEmitter } from '@angular/core';
import { FirmaRevisionService } from 'src/app/services/firma_revision/firma-revision.service';



@Component({
  selector: 'app-validacion-boton',
  templateUrl: './validacion-boton.component.html',
  styleUrls: ['./validacion-boton.component.css']
})
export class ValidacionBotonComponent implements OnInit {

  @Input() id: string = '';
  @Input() database: string = '';
  @Input() data: any = [];
  @Output() listarChild: EventEmitter<any> = new EventEmitter<any>();
 
  
 

  constructor(
    private FirmaRevisionService: FirmaRevisionService,
  ) { }

  ngOnInit() {
  }




  checkRole() {
    
    try {
      if ( localStorage.getItem('role').localeCompare('ROLE_ADMIN') == 0 ) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
     
  }
  
  checkRevision() {
    // console.log('data.revision',this.data.revision);
    try {
      if ( this.data.revision == null || this.data.revision == undefined  ) {
        return false;
      } else {
         if ( (this.data.revision as string).length == 0 ) {
           return false;
         }
        if ( (this.data.revision as string).length > 1 ) { 
          if ((this.data.revision as string).localeCompare('-') == 0 ) {
            return false;
          }
          return true;
        } else {
          return false;
        }
       
      }
    } catch (error) {
      return false;
    }
     
  }
  changeValueRevision( ) {
  
    console.log('data.revision',this.data.revision);
      
    try {
     
      if (this.data.revision == null || this.data.revision == undefined || this.data.revision.length == 0 || this.data.revision.localeCompare('-') == 0) {
        //console.log(data, this.database);
        let revision = JSON.parse(localStorage.getItem('calidad_user_tag_1'));
        //console.log(revision);
        
        let firma = {
          revision: revision.name,
          id: this.data.id,
          database: this.database 
        }
        this.FirmaRevisionService.updateFirma( firma).toPromise()
        .then( resp => {
          //console.log( 'firma', resp );
          this.data.revision = revision.name;
         //this.listarChild.emit('listarChild');
        }).catch ( error => {
          console.log(' error', error );
          
        });
      } else {
        let firma = {
          revision: '',
          id: this.data.id,
          database: this.database 
        }
        this.FirmaRevisionService.updateFirma( firma).toPromise()
        .then( resp => {
          this.data.revision = '';
          //console.log( 'firma', resp );
          // this.listarChild.emit('listarChildt');
        }).catch ( error => {
          console.log(' error', error );
          
        });
      }
    } catch (error) {
      let firma = {
        revision: '-',
        id: this.data.id,
        database: this.database 
      }
      this.FirmaRevisionService.updateFirma( firma).toPromise()
      .then( resp => {
        //console.log( 'firma', resp );
        this.listarChild.emit('listarChild');
      }).catch ( error => {
        console.log(' error', error );
        
      });
    }

    
  }
  
 
}
